import { useRouter } from "next/router";
import React, { useEffect } from "react";
import LinkButton from "../../Buttons/LinkButton";

const WineVintages = (props: {
  vintages: any[],
  vintage?: string,
  onChange?: Function,
  className?: string,
  viewAllLink?: string
  year?: string
  hrefBase?: string,
}) => {
  const [vintages, setVintages] = React.useState<any[]>([]);
  useEffect(() => {
    if (props.vintages) {
      const filteredVintages = props.vintages.filter(
        (v, i, a) => a.map((val) => val.vintage).indexOf(v.vintage) === i
      );
      setVintages(filteredVintages);
    }
  }, [props.vintages]);
  return (
    <div
      className={`grid gap-1 grid-cols-4 md:grid-cols-10 grid-flow-row-dense ${ props.className }`}
    >
      {
        vintages &&
        [...vintages].sort((l,r) => l.vintage <= r.vintage ? 1 : -1).map((v) => {
          const isCurrentVintage = props.vintage && parseInt(props.vintage) === v.vintage;

          return (
            <LinkButton
              key={"wineVintage-" + v.vintage}
              type={ isCurrentVintage ? "active" : "secondary" }
              size="sm"
              className={`hover:shadow-md hover:bg-opacity-100 hover:text-white`}
              label={v.vintage === 0 ? "NV" : v.vintage}
              href={`${props.hrefBase}/${v.vintage}`}
            />
          );
          }
        )
      }
      {
        props.viewAllLink &&
        <LinkButton
          type="secondary"
          size="sm"
          className="bg-opacity-5 text-gray-900 hover:shadow-md hover:bg-opacity-100 hover:text-white col-span-2"
          label="View All"
          href={props.viewAllLink}
        />
      }
    </div>
  )
}

export default WineVintages;
